import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as DropModel from '../drop-model';
export class StackRenderer extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.raf = undefined;
        this.tabRefs = new Map();
        this.tabFillerRef = null;
        this.containerRef = null;
        this.tabDropAreas = new Map();
        this.tabFillerDropArea = null;
        this.containerDropArea = null;
        this.handleTabFillerRef = (element) => {
            this.tabFillerRef = element;
        };
        this.handleTabRef = (identifier) => (element) => {
            if (element) {
                this.tabRefs.set(identifier, element);
            }
            else {
                this.tabRefs.delete(identifier);
            }
        };
        this.updateDropAreas = () => {
            const dropResolutions = [];
            let changed = false;
            for (let i = 0; i < this.props.stack.items.length; i++) {
                const stackItem = this.props.stack.items[i];
                if (!this.tabRefs.has(stackItem.key)) {
                    continue;
                }
                const newDropArea = DropModel.computeDropArea(this.tabRefs.get(stackItem.key));
                dropResolutions.push({
                    type: 'tab',
                    dropArea: newDropArea,
                    stack: this.props.stack,
                    index: i
                });
                if (!this.tabDropAreas.has(stackItem.key) || !DropModel.dropAreasEqual(this.tabDropAreas.get(stackItem.key), newDropArea)) {
                    changed = true;
                    this.tabDropAreas.set(stackItem.key, newDropArea);
                }
            }
            if (this.tabFillerRef !== null) {
                const newDropArea = DropModel.computeDropArea(this.tabFillerRef);
                dropResolutions.push({
                    type: 'tab',
                    dropArea: newDropArea,
                    stack: this.props.stack,
                    index: this.props.stack.items.length
                });
                if (this.tabFillerDropArea === null || !DropModel.dropAreasEqual(this.tabFillerDropArea, newDropArea)) {
                    changed = true;
                    this.tabFillerDropArea = newDropArea;
                }
            }
            if (this.containerRef !== null) {
                const newDropArea = DropModel.computeDropArea(this.containerRef);
                dropResolutions.push({
                    type: 'container',
                    dropArea: newDropArea,
                    stack: this.props.stack
                });
                if (this.containerDropArea === null || !DropModel.dropAreasEqual(this.containerDropArea, newDropArea)) {
                    changed = true;
                    this.containerDropArea = newDropArea;
                }
            }
            if (changed) {
                this.props.floatyManager.registerDropResolutions(this, dropResolutions);
            }
            this.raf = window.requestAnimationFrame(this.updateDropAreas);
        };
    }
    componentDidMount() {
        const container = ReactDOM.findDOMNode(this);
        if (container instanceof Element) {
            this.containerRef = container;
        }
        this.updateDropAreas();
    }
    componentWillUnmount() {
        if (this.raf !== undefined) {
            window.cancelAnimationFrame(this.raf);
        }
        this.props.floatyManager.unregisterDropResolutions(this);
        this.containerRef = null;
    }
    render() {
        return React.createElement(this.props.floatyRenderers.stackContainerRenderer, { floatyManager: this.props.floatyManager, stack: this.props.stack },
            React.createElement(this.props.floatyRenderers.stackTabsRenderer, { floatyManager: this.props.floatyManager, stack: this.props.stack },
                this.props.stack.items.map((stackItem, index) => {
                    return React.createElement("div", { key: stackItem.key, ref: this.handleTabRef(stackItem.key) },
                        React.createElement(this.props.floatyRenderers.tabRenderer, { floatyManager: this.props.floatyManager, stack: this.props.stack, stackItemIndex: index, stackItem: stackItem }));
                }),
                React.createElement("div", { ref: this.handleTabFillerRef },
                    React.createElement(this.props.floatyRenderers.tabFillerRenderer, { floatyManager: this.props.floatyManager, stack: this.props.stack }))),
            React.createElement(this.props.floatyRenderers.contentRenderer, { key: this.props.stack.items[this.props.stack.active].key, floatyManager: this.props.floatyManager, stack: this.props.stack, stackIndex: this.props.stack.active, stackItem: this.props.stack.items[this.props.stack.active] }));
    }
}
//# sourceMappingURL=stack-renderer.js.map